import "./CheckOutPayment.css";
import CheckOutList from "../CheckOutList/CheckOutList";
import ButtonPlane from "../../UI/Button/ButtonPlane";
import Button from "../../UI/Button/Button";
import { connect } from "react-redux";
import { setPageCount } from "../../state_management/actions";
import { stateType } from "../../store";
import { confirmOrder } from "../../state_management/epics";
import { useContext, useEffect, useState } from "react";
import { CheckOutPaymentLeft } from "./CheckOutPaymentLeft";
import { ga_params_type, purchase_ga } from "../../utilities/analytics";
import { getCurrency } from "../../utilities/misc";
import { cartItem, extrasCartItem } from "../../state_management/reducers/cart";
import { proceed_val_type } from "../../state_management/reducers/order";
import { LocaleContext } from "../../AppProvider";

const CheckOutConfirm = ({
  orderId,
  Total,
  TotalDeposit,
  depositUnavailable,
  full_payment,
  cart,
  extras,
  coupon,
  resetOrder,
  paymentTypeHandler
}: {
  orderId: number;
  Total: number;
  TotalDeposit: number;
  depositUnavailable: boolean;
  full_payment: boolean;
  cart: cartItem[];
  extras: extrasCartItem[];
  coupon: string | null;
  resetOrder: () => void;
  paymentTypeHandler: (data: React.ChangeEvent<HTMLInputElement>) => void;
}) => {
  const { t } = useContext(LocaleContext);
  const [confirmError, setConfirmError] = useState(false);
  const parseCart: ga_params_type["items"] = [
    ...cart.map((item) => ({
      id: item.id,
      type: item.type,
      quantity: item.quantity,
      item: {
        name: item.item.name,
        price_with_discount: item.item.price_with_discount
      },
      extra: false
    })),
    ...extras.map((item) => ({
      id: item.id,
      type: item.type,
      item: {
        name: item.item.name,
        price_with_discount: item.item.price_with_discount
      },
      extra: true,
      quantity: item.quantity
    }))
  ];

  useEffect(() => {
    setConfirmError(false);
  }, []);

  const confirm = async (id: number) => {
    confirmOrder({ id })
      .then((res) => {
        purchase_ga({
          coupon: coupon,
          currency: getCurrency(),
          transaction_id: orderId,
          items: parseCart,
          value: Total,
          payment_type: "Credit Card"
        });

        setConfirmError(false);
        resetOrder();
      })
      .catch((err) => {
        console.log(err);
        setConfirmError(true);
      });
  };

  return (
    <div className="checkOutPayment_wrapper">
      <form
        method="POST"
        onSubmit={(e) => {
          e.preventDefault();
          confirm(orderId);
        }}
        className="checkout_form checkout_content_wrapper"
      >
        <div className="checkout_left">
          <div>
            <CheckOutPaymentLeft
              depositUnavailable={depositUnavailable}
              TotalDeposit={TotalDeposit}
              children={
                <p className="free_parag">{t("Confirm the order for free")}</p>
              }
            />
            <ConfirmButtons smallScreen />
            <div className="showSm">
              {confirmError && (
                <div id="payment-message">
                  {t("Could not confirm the order")}
                </div>
              )}{" "}
            </div>
          </div>
        </div>
        <div className="checkout_right">
          <CheckOutList buttonJSX={<ConfirmButtons />} />
          <div className="showLg">
            {confirmError && (
              <div id="payment-message">{t("Could not confirm the order")}</div>
            )}{" "}
          </div>
        </div>
      </form>
    </div>
  );
};

const mapStateToProps = (state: stateType) => ({
  pageCount: state.commonReducer.pageCount,
  orderDirect: state.orderReducer.direct,
  orderSuccess: state.orderReducer.success
});

const mapDispatchToProps = (dispatch: any) => ({
  setPageCount: (data: number) => {
    dispatch(setPageCount(data));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckOutConfirm);

const ConfirmButtons = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  ({
    pageCount,
    smallScreen,
    orderSuccess,
    orderDirect,
    setPageCount
  }: {
    pageCount: proceed_val_type;
    smallScreen?: boolean;
    orderSuccess: boolean;
    orderDirect: boolean;
    setPageCount: (data: number) => void;
  }) => {
    const { t } = useContext(LocaleContext);
    const deactivateBars = orderSuccess || orderDirect;

    return (
      <div className={`${smallScreen ? `showSm` : ``}`}>
        <div
          className={`check_list_btn_wrapper ${deactivateBars ? `direct` : ``}`}
        >
          {deactivateBars ? (
            ``
          ) : (
            <div className="check_list_btn_inner flex">
              <ButtonPlane
                onClick={() => setPageCount(pageCount - 1)}
                size="sm"
                span
              >
                {t("Back")}
              </ButtonPlane>
            </div>
          )}
          <div className="check_list_btn_inner flex">
            <Button type="submit" disabled={orderSuccess} size="sm" span>
              {t("Confirm")}
            </Button>
          </div>
        </div>
      </div>
    );
  }
);
